up.compiler('[wysiwyg-editor]', (element, data) => {
  const $element = $(element)

  let blogPostId = data.blogPostId
  let authenticity_token = document.querySelector('meta[name="csrf-token"]')['content']
  let imagePath = '/backend/blog_posts/' + blogPostId + '/images'
  let filePath = '/backend/blog_posts/' + blogPostId + '/files'

  $R('[wysiwyg-editor]', {
    buttons: ['html', 'undo', 'redo', 'format', 'bold', 'italic', 'underline', 'deleted', 'ol', 'ul', 'link', 'image', 'file'],
    minHeight: '200px',
    lang: 'de',
    linkNewTab: false,
    linkTarget: '_blank',
    imageUpload: imagePath,
    imagePosition: true,
    imageResizable: true,
    imageLink: false,
    imageData: {
      'authenticity_token': authenticity_token,
    },
    fileUpload: filePath,
    fileData: {
      'authenticity_token': authenticity_token,
    },
    plugins: ['table', 'alignment'],
  })

  return function() {
    $R('[wysiwyg-editor]', { destroy: true })
  }
})
